import React, { useEffect } from "react";
import { Button, Form, FormField, FormGroup, Icon } from "semantic-ui-react";
import { SetProp, State, BTN_ACTS } from "./sequence/AppointmentListMEH";

type SubPackageOrderDetailProps = {
  setProp: SetProp;
  AppointmentListMEHSequence?: State["AppointmentListMEHSequence"];
  packageOrders?: Record<string, any>[];
  packageDetail: Record<string, any> | null;
  buttonLoadCheck?: any;
  onOpenPackageDetail?: (packageId: number) => void;
};

const SubPackageOrderDetail = (props: SubPackageOrderDetailProps) => {
  useEffect(() => {
    return () => {
      props.setProp("AppointmentListMEHSequence.packageDetail", null);
    };
  }, []);

  return (
    <Form>
      {(props.packageOrders ?? []).map((pk: any, index: number) => (
        <React.Fragment key={pk.id}>
          <FormGroup>
            <FormField width={8} style={{ marginTop: index === 0 ? "" : "1rem", display: "flex" }}>
              <label
                style={{
                  color: pk.package_type_name === "Package" ? "#5D8439" : "#FE9500",
                }}
              >
                {pk.package_type_name} :
              </label>{" "}
              {pk.product_name}
            </FormField>
            <FormField>
              <Button
                size="mini"
                icon
                style={{ backgroundColor: "rgba(255, 222, 175, 1)" }}
                onClick={() => {
                  if (props.packageDetail?.id === pk.product) {
                    props.setProp("AppointmentListMEHSequence.packageDetail", null);

                    return;
                  }

                  props.onOpenPackageDetail?.(pk.product);
                }}
                loading={props.buttonLoadCheck?.[BTN_ACTS.GET_PACKAGE_DETAIL] === "LOADING"}
              >
                <Icon
                  name={props.packageDetail?.id === pk.product ? "chevron up" : "chevron down"}
                />
                <label style={{ marginLeft: "6px" }}>รายละเอียด Package</label>
              </Button>
            </FormField>
          </FormGroup>
          {props.packageDetail?.id === pk.product && (
            <FormGroup
              style={{
                border: "1px solid rgba(217, 217, 217, 1)",
                borderRadius: "6px",
                padding: "10px 8px",
              }}
            >
              <FormField width={16}>
                {(props.packageDetail?.items ?? []).map((item: any) => (
                  <div key={item.id} style={{ marginBottom: "24px" }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        lineHeight: "17px",
                        marginBottom: "6px",
                      }}
                    >
                      {item.product_name}
                    </div>
                    {item.product_name_en && (
                      <div
                        style={{
                          fontSize: "13px",
                          lineHeight: "14px",
                          color: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        {item.product_name_en}
                      </div>
                    )}
                  </div>
                ))}
              </FormField>
            </FormGroup>
          )}
        </React.Fragment>
      ))}
    </Form>
  );
};

export default React.memo(SubPackageOrderDetail);
